{
	"event": "Evento",
	"logout": "Cerrar sesión 123",
	"org": "Organización",
	"place": "Lugar",
	"language": "Idioma"
}
